<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div>

		<!-- PROGRESS STEPS -->
		<section class="section-steps">
			 <progress-steps :steps="13" :step="stage" :stagechanges="getStages"></progress-steps>
		</section>

		<div class="container-small">
			<div class="add-page">

				<!-- DETAILS LABEL -->
				<div v-if="stage > stages.MAP" class="add-page__details-label__wrapper mdc-layout-grid">
					<div class="add-page__details-label">
					   {{ propertyAddress(property) }}
					   {{ postcodeShort }} <br/>
					   <span v-if="property.bedrooms == 0">Studio </span><span v-if="property.bedrooms !== 0 && property.bedrooms > -1">{{ property.bedrooms }} bedroom </span> {{ propertyTypeName(property.type).toLowerCase() }} <br>
					   <span v-if="property.price > 0">{{ formatCurrency(property.price) }}</span> <span v-if="property.price > 0 && property.serviceType === serviceType.LETTINGS">{{ property.rentFrequency }}</span>
					</div>
				</div>

				<!-- SERVICE TYPE AND STATUS -->
				<section class="section-typeAndStatus" v-if="stage == stages.TYPE_AND_STATUS">
					<h2 class="margin-top-0">Add Property</h2>

					<!-- Service Type -->
					<section class="subsection-serviceType">
						<option-buttons v-model="property.serviceType" :items="serviceTypes.map(function(obj) {return [obj.id, obj.name];})" title="Service Type" :cols="2" @changed="statusChanged"></option-buttons>
					</section>

					<!-- Sales Status -->
					<section class="subsection-salesStatus" v-if="property.serviceType == serviceType.SALES">
						<option-buttons v-model="property.status" :items="propertyStatusArray" title="Status" :cols="1"></option-buttons>
					</section>

					<!-- Lettings Status -->
					<section class="subsection-lettingsStatus" v-else>
						<option-buttons v-model="property.status" :items="propertyStatusArray" title="Status" :cols="1"></option-buttons>
					</section>


					<!-- House/Flat Share -->
					<section class="subsection-share" v-if="property.serviceType == 'lettings'">
						<div class="mdc-layout-grid">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12 mdc-form-field">
								<div class="mdc-checkbox">
									<input id="house-flate-share" value="1" class="mdc-checkbox__native-control" type="checkbox" v-model="property.share">
									<div class="mdc-checkbox__background"></div>
								</div>
								<label for="house-flate-share">House/Flat Share</label>
							</div>
						</div>
					</section>

					<div class="mdc-layout-grid">
						<button class="mdc-button mdc-button--raised" v-on:click="stage = stages.ADDRESS" v-if="property.serviceType !== -1 && property.status !== -1">Next</button>

						<a class="back-button black-link" href="/">&lt; back</a>
					</div>
				</section>

				<!-- ADDRESS -->
				<section class="section-address" v-if="stage == stages.ADDRESS && !addressManually">
					<h2 class="margin-top-0">Address</h2>
					<!-- Address -->
					<div v-if="!addressManually" class="margin-top-60 mdc-layout-grid">
						<google-places-input v-on:googlePlacesUpdated="googlePlacesUpdated" placeholder="Type '28 Street name'" @setDefault="setDefaultAddress" v-model="defaultAddress" @notFullPostcode="isNotFullPostcode = arguments[0]"></google-places-input>
						<!-- Enter details manually -->
						<a href="#" @click.prevent="addressManually = true">Enter details manually</a>
					</div>

					<a class="back-button black-link" @click="stage = stages.TYPE_AND_STATUS">&lt; back</a>
				</section>

				<!-- ADDRESS MANUALLY -->
				<section class="section-addressManually mdc-layout-grid" v-if="stage == stages.ADDRESS && addressManually">
					<address-input v-model="property.address" :attentionSymbol="attentionSymbol" @notFullPostcode="isNotFullPostcode = arguments[0]" :notFullPostcode="isNotFullPostcode"></address-input>
					<button class="mdc-button mdc-button--raised margin-top-24" v-on:click="manualMap" :disabled="property.address.buildingNumber == '' || property.address.flatNumber == '' && isNotFullPostcode">Next</button>
					<a href="#" class="back-button black-link" @click.prevent="addressManually = false; defaultAddress = ''">&lt; back</a>
				</section>

			<!-- MAP -->
			<section class="section-map mdc-layout-grid" v-if="stage == stages.MAP">
				<!-- Map and address -->
				<div class="">
				<google-map class="section-map" v-bind:lat="property.latitude" v-bind:lng="property.longitude"></google-map>

				<div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="showFlatNumberInput">
					 <input id="flatNumber02" class="mdc-textfield__input" type="text" v-model="property.address.flatNumber" :class="{'input--focus' : property.address.flatNumber !== ''}" placeholder="">
					 <label for="flatNumber02" class="mdc-textfield__label mdc-textfield__label--float-above">Enter number/letter if Flat</label>
					  </div>
				<div class="width-100 mdc-textfield mdc-textfield--upgraded" v-if="showPropertyNumberInput">
					 <input id="streetNumber02" class="mdc-textfield__input" type="text" v-model="property.address.number" :class="{'input--focus' : property.address.number !== ''}" placeholder="">
					 <label for="streetNumber02" class="mdc-textfield__label mdc-textfield__label--float-above">Enter building number or name</label>
				</div>
				</div>
				<div class="address-summary margin-top-24">
					<span class="address-number" v-if="property.address.flatNumber != ''">{{property.address.flatNumber}}, </span>
					<span class="address-number" v-if="property.address.buildingNumber != ''">{{property.address.buildingNumber}} </span>
					<span class="address-street">{{property.address.street}}</span><br>
					<span class="street-town" v-if="property.address.town != ''">{{property.address.town}}<br></span>
					<span class="street-postcode">{{property.address.postcode}}</span>
				</div>
            <a href="#" @click.prevent="addressManually = true; stage = stages.ADDRESS;">Address not correct?</a>

				<button class="mdc-button mdc-button--raised margin-top-24" v-on:click="stage = stages.BEDROOMS">Next</button>
				<a href="#" class="back-button black-link" @click.prevent="addressManually = true; stage = stages.ADDRESS;">&lt; back</a>
			</section>

				<!-- ADDRESS MANUALLY -->
				<!-- <section class="section-addressManually mdc-layout-grid" v-if="stage == stages.ADDRESS && addressManually">
					<address-input v-model="property.address" :attentionSymbol="attentionSymbol" @notFullPostcode="isNotFullPostcode = arguments[0]" :notFullPostcode="isNotFullPostcode"></address-input>
					<button class="mdc-button mdc-button--raised margin-top-24" v-on:click="stage = stages.MAP" :disabled="!property.address.addressNotEmpty || isNotFullPostcode">Next</button>
					<a href="#" class="back-button black-link" @click.prevent="addressManually = false; defaultAddress = ''">&lt; back</a>
				</section> -->

				<!-- BEDROOMS -->
				<section class="section-bedrooms" v-if="stage == stages.BEDROOMS">
					 <option-buttons :showMoreButton="true" v-model="property.bedrooms" :items="bedrooms.map(function(obj) {return [obj.bedrooms, obj.name];})" :numberOfOptionsToShow="3" @changed="bedroomsChanged" :cols="2" title="Bedrooms"></option-buttons>
				</section>

        <!-- LIVINGROOMS -->
				<section class="section-livingrooms" v-if="stage == stages.BEDROOMS">
					 <option-buttons :showMoreButton="true" v-model="property.livingrooms" :items="livingrooms.map(function(obj) {return [obj.livingrooms, obj.name];})" :numberOfOptionsToShow="3" @changed="bedroomsChanged" :cols="2" title="Reception rooms"></option-buttons>
				</section>

        <!-- BATHROOMS -->
				<section class="section-bathrooms" v-if="stage == stages.BEDROOMS">
					 <option-buttons :showMoreButton="true" v-model="property.bathrooms" :items="bathrooms.map(function(obj) {return [obj.bathrooms, obj.name];})" :numberOfOptionsToShow="3" @changed="bedroomsChanged" :cols="2" title="Bathrooms"></option-buttons>
				</section>

        <section class="section-bedrooms" v-if="stage == stages.BEDROOMS">
          <div class="mdc-layout-grid">
            <button class="mdc-button mdc-button--raised" @click.prevent="stage = stages.TYPE_AND_SUBTYPE" :disabled="property.bedrooms === -1 && property.bathrooms === -1 && property.livingrooms === -1">Next</button>
            <a href="#" class="back-button black-link" @click.prevent="stage = stages.MAP">&lt; back</a>
          </div>
        </section>

				<!-- TYPE AND SUBTYPE -->
				<section class="section-type" v-if="stage == stages.TYPE_AND_SUBTYPE">
					<option-buttons :showMoreButton="false" v-model="property.type" :items="propertyTypes.map(function(obj) {return [obj.id, obj.name];})" @changed="typeChanged" :cols="2" title="Type"></option-buttons>
					<hr class="section-type__divider">
					<option-buttons v-model="property.subtype" :items="propertySubtypesArray" @changed="subtypeChanged" :cols="2" title="" :showMoreButton="false"></option-buttons>
					<!-- Show Flat subtypes button -->
					<!-- <button v-if="(property.bedrooms !== -1 && property.bedrooms !== 0) && property.type === 'flat' && !showFlats" class="mdc-button mdc-button--flat margin-bottom-24" @click="showFlats = true; property.subtype = -1">Specify flat subtype (Optional)</button> -->

					<!-- Flat subtypes -->
					<!-- <section class="subsection-subtype" v-if="showFlats">
						<option-buttons v-model="property.subtype" :cols="1" :items="propertySubtypesArray" @changed="subtypeChanged"></option-buttons>
					</section> -->
					<div class="mdc-layout-grid">
					  <button class="mdc-button mdc-button--raised" @click.prevent="furnishingOrPrice" :disabled="property.type === -1 || property.subtype === -1">Next</button>
					  <a href="#" class="back-button black-link" @click.prevent="stage = stages.BEDROOMS">&lt; back</a>
					</div>
				</section>

				<!-- FURNISHING STATUS -->
				<section class="section-furnishing" v-if="stage == stages.FURNISHING">
					<option-buttons v-model="property.furnishingStatus" :items="furnishingStatusArray" :cols="1" title="Furnishing" :showMoreButton="false"></option-buttons>
					<div class="mdc-layout-grid">
						<button class="mdc-button mdc-button--raised" v-on:click="stage = stages.PRICE" :disabled="property.furnishingStatus === -1">Next</button>
						<a href="#" class="back-button black-link" @click.prevent="stage = stages.TYPE_AND_SUBTYPE">&lt; back</a>
					</div>
				</section>

				<!-- MARKETING PRICE -->
				<section class="section-price margin-top-24" v-if="stage == stages.PRICE">
					<div class="mdc-layout-grid">
						<!-- Price -->
						<currency-input v-model="property.price" @newValue="priceChanged" placeholder="£ Price"></currency-input>

            <section class="subsection-salesStatus" v-if="property.serviceType == serviceType.SALES">
              <option-buttons v-model="property.tenure" :items="[['freehold', 'Freehold'],['leasehold', 'Leasehold'],['freehold-share', 'Share of freehold']]" title="Tenure Status" :cols="1"></option-buttons>
            </section>
						<!-- Lettings Price -->
						<div class="editable-options__select" v-if="property.serviceType === serviceType.LETTINGS">
							<select v-model="property.rentFrequency">
							<option value="PCM">PCM</option>
							<option value="PW">PW</option>
							</select>
						</div>

						<!-- Text -->
						<div class="price-term-default margin-bottom-24 margin-top-24" v-if="!showPriceTerms && property.newPrice !== ''">We'll default the pricing terms to "Asking price of"</div>

						<!-- Manually set button -->
						<div class="margin-bottom-24">
							<button class="mdc-button mdc-button--flat" v-if="!showPriceTerms && property.newPrice !== ''" @click="property.priceTerm = ''; showPriceTerms = true">Manually set terms</button>
						</div>

						<!-- Price Terms -->
						<div v-if="showPriceTerms">
							<option-buttons v-model="property.priceTerm" :items="priceTermsArray" :cols="1" :showMoreButton="false"></option-buttons>
						</div>

						<button class="mdc-button mdc-button--raised margin-top-24" :disabled="property.newPrice === '' || property.newPrice === undefined || property.priceTerm === ''" @click="property.price = property.newPrice; stage = stages.PHOTO">Next</button>
						<a href="#" class="back-button black-link" @click.prevent="property.serviceType === serviceType.LETTINGS ? stage = stages.FURNISHING : stage = stages.TYPE_AND_SUBTYPE">&lt; back</a>
					</div>
				</section>


			<!-- PHOTO -->
			<section class="section-photo" v-if="stage == stages.PHOTO">
				<h2>Photos</h2>
				<!-- <div class="col col-xs-12">
					<img src="/static/svg/camera.svg" alt="Add Photo" class='icon-image icon-image--quarter'>
				</div> -->
					<!-- <div v-if="imageUploaded" class="s3__image-grid">
						<div v-for="image in property.images" class="s3__image" :class="{'s3__image-main': image === mainImage}" :style="{backgroundImage: 'url(' + s3url(image, 'medium') + ')'}"></div>
					</div> -->
				<div v-if="responsive">
					<div v-for="image in property.images" class="s3__image" :class="{'s3__image-main': image === mainImage}" :style="{backgroundImage: 'url(\'' + s3url(image, 'medium') + '\')'}">
					</div>
				</div>
				<div v-else>
					<draggable class="s3__image-grid" v-if="imageUploaded" v-model="property.images" :list="property.images">
						<div v-for="image in property.images" class="s3__image" :class="{'s3__image-main': image === mainImage}" :style="{backgroundImage: 'url(\'' + s3url(image, 'medium') + '\')'}">
							<span class="editable-photos__remove-btn" @click="remove(index)"><i class="ico ico-delete"></i></span>
						</div>
					</draggable>
				</div>

				<div class="mdc-layout-grid">
					<s3 key="s3-images" v-model="property.images" :label="property.images.length > 0 ? morePhotosStr : addPhotosStr" @complete="imageUploaded = true" @uploading="isUploading = arguments[0]"></s3>
					<div class="mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
							<span class="s3__hint--small">You can add multiple photos.</span>
						</div>
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12" v-if="property.images.length < 1">
							<span class="s3__hint">Add at least one photo to get published on the portal.</span>
						</div>
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
							<span class="s3__hint s3__hint--italic">We only support .jpg, .jpeg and .png files.</span>
						</div>
					</div>
				</div>

				<!-- <div v-if="imageUploaded" class="s3__image-grid">
					<div v-for="image in property.images" class="s3__image" :style="{backgroundImage: 'url(' + s3url(image, 'medium') + ')'}"></div>
				</div> -->

				<!-- <s3 key="s3-images" v-model="property.images" @complete="imageUploaded = true" @uploading="isUploading = arguments[0]"></s3> -->
				<div class="mdc-layout-grid">
				   <button class="mdc-button mdc-button--raised margin-top-24" v-on:click="stage = stages.FLOORPLANS" :disabled="isUploading">Next</button>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.PRICE">&lt; back</a>
				</div>
			</section>

			<!-- FLOORPLANS -->
			<section class="section-photo" v-if="stage == stages.FLOORPLANS">
				 <h2>Floor Plans</h2>

				 <div v-if="property.floorplans.length > 0" class="s3__image-grid">
					<div v-for="image in property.floorplans" class="s3__image" :style="{backgroundImage: 'url(\'' + s3url(image, 'medium') + '\')'}"></div>
				</div>

				 <div class="mdc-layout-grid">
					  <s3 key="s3-floorplans" label="Add Floor Plans" v-model="property.floorplans" @uploading="isUploading = arguments[0]"></s3>
				 </div>

				 <div class="mdc-layout-grid">
					  <button class="mdc-button mdc-button--raised margin-top-24" v-on:click="stage = stages.EPC" :disabled="isUploading">Next</button>
					  <a href="#" class="back-button black-link" @click.prevent="stage = stages.PHOTO">&lt; back</a>
				 </div>
			</section>

			<!-- EPC -->
			<section class="section-epc" v-if="stage == stages.EPC">
				<h2>EPC</h2>

				<option-buttons :showMoreButton="false" v-model="property.epcLetter" :items="epcLetter.map(function(obj) {return [obj.letter, obj.name];})" :numberOfOptionsToShow="10" :cols="4" title="Choose EPC letter"></option-buttons>

				<div v-if="epcUploaded" class="s3__image-grid">
					<div v-if="property.epc.includes('.pdf')">
						<a :href="s3url(property.epc)" target="_blank">View EPC</a>
					</div>
					<div v-else>
						<div class="s3__image" :style="{backgroundImage: 'url(\'' + s3url(property.epc, 'medium') + '\')'}"></div>
					</div>
				</div>

				<div class="mdc-layout-grid">
               <s3 key="s3-epc" v-model="property.epc" :single="true" label="Upload EPC Graph" extensions=".png, .jpeg, .jpg, .pdf, .PNG, .JPEG, .JPG, .PDF" @complete="epcUploaded = true" @uploading="isUploading = arguments[0]"></s3>
            	<span class="s3__hint">Hint: Please submit your EPC graph. If you don't have one you can generate it from <a href="http://epc.rightmove.co.uk/epcgenerator" target="_blank">here</a><br></span>
         	</div>
				<div class="mdc-layout-grid">
				   <button class="mdc-button mdc-button--raised margin-top-24" v-on:click="stage = stages.BROCHURE" :disabled="isUploading">Next</button>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.FLOORPLANS">&lt; back</a>
				</div>
			</section>

			<!-- BROCHURE -->
			<section class="section-brochure" v-if="stage == stages.BROCHURE">
				<h2>Brochure</h2>

				<div v-if="brochureUploaded">
					<a :href="s3url(property.brochure)" target="_blank">View brochure</a>
				</div>

				<div class="mdc-layout-grid">
				   <s3 key="s3-brochure" v-model="property.brochure" :single="true" label="Upload Brochure PDF" extensions=".pdf, .PDF" @complete="brochureUploaded = true" @uploading="isUploading = arguments[0]"></s3>
				</div>

				<div class="mdc-layout-grid">
				   <button class="mdc-button mdc-button--raised margin-top-24" v-on:click="activateFeatures" :disabled="isUploading">Next</button>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.EPC">&lt; back</a>
				</div>
			</section>

			<!-- FEATURES -->
			<section class="section-features" v-if="stage == stages.FEATURES">
				<h2>Property features</h2>

				<div class="mdc-layout-grid">
				   <editable-features v-model="property.features" @hasThree='hasThreeFeatures = !arguments[0];'></editable-features>
				   <button class="mdc-button mdc-button--raised margin-top-24" v-on:click="stage = stages.DESCRIPTION" :disabled="hasThreeFeatures">Next</button>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.BROCHURE">&lt; back</a>
				</div>
			</section>

			<!-- SHORT DESCRIPTION -->
			<section class="section-description" v-if="stage == stages.DESCRIPTION">
				<h2>Short description</h2>
				<div class="margin-bottom-24 margin-top-24 mdc-layout-grid">
				   <div class="mdc-textfield mdc-textfield--textarea">
				       <textarea class="mdc-textfield__input description-textarea" v-model="property.shortDescription" placeholder="Short description (limited to 250 characters)" maxlength="250" @keyup="charsLeft = 250 - $event.target.value.length; charsUsed = $event.target.value.length"></textarea>
				   </div>
				   <div class="description-counter" v-if="property.shortDescription !== ''">{{charsUsed}}/250<br>You have {{charsLeft}} characters remaining</div>
				</div>
				<div class="mdc-layout-grid">
				   <button class="mdc-button mdc-button--raised" v-on:click="stage = stages.LONG_DESCRIPTION" :disabled="property.shortDescription === ''">Next</button>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.FEATURES">&lt; back</a>
				</div>
			</section>

			<!-- LONG DESCRIPTION -->
			<section class="section-description" :class="{'long-description-margins': property.longDescription !== ''}"  v-if="stage == stages.LONG_DESCRIPTION">
				<h2>Long description</h2>
				<div class="mdc-layout-grid">
				   <div class="mdc-textfield mdc-textfield--textarea margin-bottom-24">
				       <textarea class="mdc-textfield__input description-textarea" v-model="property.longDescription" placeholder="Long description (No limit. Go wild!)"></textarea>
				   </div>
				</div>
				<div class="mdc-layout-grid">
				   <button v-if="proPortalsPerProperty" class="mdc-button mdc-button--raised" v-on:click="stage = stages.PORTALS" :disabled="property.longDescription === ''">Next</button>
				   <button-with-spinner v-if="!proPortalsPerProperty" :isSaving="isSaving" :text="savingText" :customMethod="saveProperty" :disabled="property.longDescription === '' || isSaving"></button-with-spinner>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.DESCRIPTION">&lt; back</a>
				</div>
			</section>

			<!-- PORTALS -->
			<section class="section-portals" v-if="stage == stages.PORTALS">
				<h2>Portals</h2>
				<p>
					This property will be published on the following portals:<br>
					(if validated by the portal)
				</p>
				<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6 mdc-form-field" v-for="portal in portalsList">
					<div class="mdc-checkbox">
						<input :id="portal.id" :value="portal.id" class="mdc-checkbox__native-control" type="checkbox" v-model="portalsSelection">
						<div class="mdc-checkbox__background">
							<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
					        <path class="mdc-checkbox__checkmark-path"
					              fill="none"
									  stroke="white"
									  stroke-width="3.5px"
					              d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
					      </svg>
							<div class="mdc-checkbox__mixedmark"></div>
						</div>
					</div>
					<label :for="portal.id">{{ portal.name }}</label>
				</div>
				<div class="mdc-layout-grid">
				   <button-with-spinner :isSaving="isSaving" :text="savingText" :customMethod="saveProperty" :disabled="isSaving"></button-with-spinner>
				   <a href="#" class="back-button black-link" @click.prevent="stage = stages.LONG_DESCRIPTION">&lt; back</a>
				</div>
			</section>

		</div>
	</div>
</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import GooglePlacesInput  from '../components/GooglePlacesInput.vue';
import GoogleMap          from '../components/GoogleMap.vue';
import ProgressSteps      from '../components/ProgressSteps.vue';
import OptionButtons      from '../components/OptionButtons.vue';
import CurrencyInput      from '../components/CurrencyInput.vue';
import S3                 from '../components/S3.vue';
import EditableFeatures   from '../components/EditableFeatures.vue';
import AddressInput			  from '../components/AddressInput.vue';
import ButtonWithSpinner  from '../components/ButtonWithSpinner.vue';
import draggable from 'vuedraggable';

export default {
	data: function() {
		return {
			stages: {
				TYPE_AND_STATUS:  0,
				ADDRESS:          1,
				MAP:              2,
				BEDROOMS:			3,
				TYPE_AND_SUBTYPE: 4,
				FURNISHING:       5,
				PRICE:            6,
				PHOTO:            7,
				FLOORPLANS:       8,
				EPC:              9,
				BROCHURE:         10,
				FEATURES:         11,
				DESCRIPTION:      12,
				LONG_DESCRIPTION: 13,
				PORTALS:		  14,
				SAVE:             15
			},
			stage: 0,
			serviceType: {
				SALES: 'sales',
				LETTINGS: 'lettings'
			},
			property: {
				serviceType: 'sales',
				status: 'for-sale',
				latitude: 0,
				longitude: 0,
				bedrooms: -1,
				type: -1,
				subtype: -1,
				price: '',
				newPrice: '',
				rentFrequency: 'PCM',
				priceTerm: 'asking-price-of',
				image: '',
				images: [],
				floorplans: [],
				epc: '',
				epcLetter: '',
				brochure: '',
				features: [],
				shortDescription: '',
				longDescription: '',
				furnishingStatus: '',
        tenure: null,
				archived: false,
				share: false,
				address: {
					buildingNumber: '',
					street: '',
					postcode: '',
					flatNumber: '',
					town: '',
					county: '',
					addressNotEmpty: false
				},
				portals: []
			},
			bedrooms: [
				{bedrooms: 0, name: 'Studio'},
				{bedrooms: 1, name: '1 bedroom'},
				{bedrooms: 2, name: '2 bedrooms'},
				{bedrooms: 3, name: '3 bedrooms'},
				{bedrooms: 4, name: '4 bedrooms'},
				{bedrooms: 5, name: '5 bedrooms'},
				{bedrooms: 6, name: '6 bedrooms'},
				{bedrooms: 7, name: '7 bedrooms'},
				{bedrooms: 8, name: '8 bedrooms'},
				{bedrooms: 9, name: '9 bedrooms'},
				{bedrooms: 10, name: '10 bedrooms'},
				{bedrooms: 11, name: '10+ bedrooms'}
			],
			livingrooms: [
        {livingrooms: 0, name: 'No reception room'},
				{livingrooms: 1, name: '1 reception room'},
				{livingrooms: 2, name: '2 reception rooms'},
				{livingrooms: 3, name: '3 reception rooms'},
				{livingrooms: 4, name: '4 reception rooms'},
				{livingrooms: 5, name: '5 reception rooms'},
				{livingrooms: 6, name: '6 reception rooms'},
				{livingrooms: 7, name: '7 reception rooms'},
				{livingrooms: 8, name: '8 reception rooms'},
				{livingrooms: 9, name: '9 reception rooms'},
				{livingrooms: 10, name: '10 reception rooms'},
				{livingrooms: 11, name: '10+ reception rooms'}
			],
			bathrooms: [
				{bathrooms: 0, name: 'No bathroom'},
				{bathrooms: 1, name: '1 bathrooms'},
				{bathrooms: 2, name: '2 bathrooms'},
				{bathrooms: 3, name: '3 bathrooms'},
				{bathrooms: 4, name: '4 bathrooms'},
				{bathrooms: 5, name: '5 bathrooms'},
				{bathrooms: 6, name: '6 bathrooms'},
				{bathrooms: 7, name: '7 bathrooms'},
				{bathrooms: 8, name: '8 bathrooms'},
				{bathrooms: 9, name: '9 bathrooms'},
				{bathrooms: 10, name: '10 bathrooms'},
				{bathrooms: 11, name: '10+ bathrooms'}
			],
			epcLetter: [
				{letter: 'a', name: 'A'},
				{letter: 'b', name: 'B'},
				{letter: 'c', name: 'C'},
				{letter: 'd', name: 'D'},
				{letter: 'e', name: 'E'},
				{letter: 'f', name: 'F'},
				{letter: 'g', name: 'G'}
			],
			propertyTypes: [{id: 'house', name: 'House'}, {id: 'flat', name: 'Flat'}],
			serviceTypes: [{id: 'sales', name: 'Sales'}, {id: 'lettings', name: 'Lettings'}],
			showNextOnPrice: false,
			imageUploaded: false,
			epcUploaded: false,
			brochureUploaded: false,
			isUploading: false,
			hasThreeFeatures: false,
			showPriceTerms: false,
			enterPostcodeManually: false,
			showFlatNumberInput: false,
			showPropertyNumberInput: false,
			charsLeft: 250,
			charsUsed: 0,
			showPropertyType: true,
			showFlatSubtypes: false,
			defaultAddress: '',
			addressManually: false,
			isSaving: false,
			savingText: 'Save',
			regexHasAStreetNumber: /^(\d+-?)\d*[a-zA-Z]?/,
			rmActive: false,
			zooplaActive: false,
			customActive: false,
			attentionSymbol: true,
			isNotFullPostcode: false,
			showFlats: true,
			morePhotosStr: 'Add More',
			addPhotosStr: 'Add Photos',
			showMore: true,
			windowWidth: 0,
			responsive: false,
			portalsList: [],
			portalsSelection: []
		}
	},
	mixins: [utils],
	components: {
		'google-places-input': GooglePlacesInput,
		'google-map': GoogleMap,
		'option-buttons': OptionButtons,
		'currency-input': CurrencyInput,
		'progress-steps': ProgressSteps,
		's3': S3,
		'editable-features': EditableFeatures,
		'button-with-spinner': ButtonWithSpinner,
		'address-input': AddressInput,
		'draggable': draggable
	},
	watch: {
		 property: {
			handler: function () {
				if (this.property.address && this.property.address.latitude) {
					this.property.latitude = this.property.address.latitude;
					this.property.longitude = this.property.address.longitude;
					delete this.property.address.latitude;
					delete this.property.address.longitude;
				}
			},
			deep: true
		 }
	},
	methods: {
		manualMap: function() {
			if (this.property.address && this.property.address.latitude) {
				this.property.latitude = this.property.address.latitude;
				this.property.longitude = this.property.address.longitude;
				delete this.property.address.latitude;
				delete this.property.address.longitude;
			}
			this.stage = this.stages.MAP;
		},
		googlePlacesUpdated: function(place) {
			if (place.street == '' || place.postcode == '') {
				return;
			}
			this.property.address.buildingNumber = place.buildingNumber;
			this.property.address.street = place.street;
			this.property.address.postcode = place.postcode;
			this.property.address.town = place.town;
			this.property.address.county = place.county;
			this.property.latitude = place.latitude ? place.latitude : place.lat;
			this.property.longitude = place.longitude ? place.longitude : place.lng;
			this.property.address.addressNotEmpty = true;

			this.showFlatNumberInput = this.property.address.flatNumber == '';
			this.showPropertyNumberInput = this.property.address.buildingNumber == '';

			if(this.isNotFullPostcode || this.property.address.buildingNumber == '' || this.property.address.flatNumber) {
				this.addressManually = true;
			} else if(this.property.address.buildingNumber != '' && this.property.address.street != '' && this.property.address.postcode != '' && this.property.address.town != '' && this.property.address.county != '') {
				this.stage = this.stages.MAP;
			} else {
				 this.addressManually = false;
			}
		},
		latLngGenerated: function(location) {
			this.property.latitude = location.lat();
			this.property.longitude = location.lng();
		},
		setDefaultAddress: function(value) {
			this.defaultAddress = value;
			this.property.street = value;
		},
		statusChanged: function() {
			// if Studio or if there's a flat number
			if (this.property.serviceType === 'sales') {
				this.property.status = 'for-sale';
			} else {
				this.property.status = 'to-let';
			}
		},
		bedroomsChanged: function() {
			// if Studio or if there's a flat number
			if (this.property.bedrooms === 0 || this.property.address.flatNumber !== '') {
				// property type will be Flat and Subtype Flat
				this.property.type = 'flat';
				this.property.subtype = 'flat';
				// if Studio, subtype will be Studio
				if (this.property.bedrooms === 0) {
					this.property.subtype = 'studio';
				}
			} else {
				this.property.type = -1;
				this.property.subtype = -1;
			}
			this.showPropertyType = true;
			this.showFlats = false;
		},
		typeChanged: function() {
			// if type Flat, default subtype to Flat
			if (this.property.type === 'flat') {
				this.property.subtype = 'flat';
			} else {
				this.property.subtype = -1;
			}
		},
		subtypeChanged: function() {
			// If flat subtype, hide type
			if (this.property.type == 'flat') {
				this.showPropertyType = false;
			}
		},
		changeServiceTypeAndStatus: function() {
			this.stage = this.stages.TYPE_AND_STATUS;
			this.property.serviceType = -1;
			this.property.status = -1;
		},
		cancelServiceTypeAndStatus: function() {
			// if service type is sales or none and no sales status was chosen
			if (this.property.serviceType === this.serviceType.SALES || this.property.serviceType === -1) {
				this.property.serviceType = this.serviceType.SALES;
				if (this.property.status === -1) {
					this.property.status = -1;
				}
			} else {
				//if service type is lettings and no lettings status was chosen
				if (this.property.status === -1) {
					this.property.status = -1;
				}
			}

			this.stage = this.stages.ADDRESS;
		},
		furnishingOrPrice: function() {
					 if(this.property.serviceType === this.serviceType.LETTINGS) {
						this.stage = this.stages.FURNISHING;
				  } else {
						this.stage = this.stages.PRICE;
				  }
		},
		activateFeatures: function() {
			if (this.property.features.length === 0) {
				this.property.features = [];
				this.property.features.push(this.bedrooms[this.property.bedrooms].name);
				if(this.property.bedrooms == 0) {
					this.property.features.push('Flat');
				} else {
					this.property.features.push(this.propertySubtypes[this.property.subtype]);
				}
				if(this.property.serviceType === 'lettings') {
					var furnishingName = this.$store.state.propertyLists.furnishingStatus[this.property.furnishingStatus];
					if (furnishingName === 'both') {
						this.property.features.push('Furnished or Unfurnished');
					} else {
						// furnishingName = furnishingName.toString().replace(/,/g, '');
						this.property.features.push(furnishingName.charAt(0).toUpperCase() + furnishingName.substr(1).toLowerCase());
					}
				} else {
					this.property.features.push('Based in ' + this.property.address.town);
				}
			}
			this.stage = this.stages.FEATURES;
		},
		cleanFeatures: function(features) {
			return features.filter(function(feature) {
				return feature !== '';
			});
		},
		saveProperty: async function() {
			var self = this;
			this.isSaving = true;
			this.savingText = 'Saving property...';
			this.property.features = this.property.features.filter(function(n){ return n != ''});
			let lat = this.property.latitude;
			let lng = this.property.longitude;

			var property = {
				address: {
					buildingNumber: this.property.address.buildingNumber,
					flatNumber: this.property.address.flatNumber,
					street: this.property.address.street ? this.property.address.street.trim() : this.property.address.street,
					postcode: this.property.address.postcode,
					town: this.property.address.town ? this.property.address.town.trim() : this.property.address.town,
					county: this.property.address.county ? this.property.address.county.trim() : this.property.address.county,
					latitude: lat,
					longitude: lng
				},

				serviceType: this.property.serviceType,
				type: this.property.type,
				subtype: this.property.subtype,
				status: this.property.status,
				price: this.property.price,
				bedrooms: this.property.bedrooms,
				livingrooms: this.property.livingrooms,
				bathrooms: this.property.bathrooms,
				share: this.property.share,

				images: this.property.images,

				features: this.property.features.map(feature => feature.trim()).filter(function(featureItem) {
					return featureItem !== '';
				}),
				shortDescription: this.property.shortDescription.trim(),
				longDescription: this.property.longDescription.trim(),

				floorplans: this.property.floorplans,
				epc: this.property.epc,
				epcLetter: this.property.epcLetter,
				brochure: this.property.brochure,

				rentFrequency: this.property.rentFrequency,
				furnishingStatus: this.property.furnishingStatus,
				priceTerms: this.property.priceTerm,

				archived: this.property.archived,

        tenure: this.property.tenure,
				portalsExclusion: this.portalsList.filter(function(portalItem) {
					return self.portalsSelection.indexOf(portalItem.id) == -1;
				}).map(function(portalItem) {
					return portalItem.id;
				})
			}

			try {
				var response = await api({endpoint: this.config.services.properties, path: '/', method: 'POST', body: property});
				var steps = ['Preparing images...'];
				if(self.rmActive) {
					steps.push('Sending to Rightmove...');
				}
				if(self.zooplaActive) {
					steps.push('Sending to Zoopla...');
				}
				if(self.customActive) {
					steps.push('Preparing property for your custom portal...');
				}
				steps.push('All done... Redirecting to your property...');

				var nextStep = 0;
				var interval = setInterval(function() {
					if(nextStep >= steps.length) {
						clearInterval(interval);
						self.$router.push('/properties/' + response.propertyId);
					} else {
						self.savingText = steps[nextStep];
						nextStep++;
					}
				}, 1500);
			} catch(err) {
				this.isSaving = false;
				this.savingText = 'Saving property has failed! Please try again!';
				throw {
					type: 'adding-property',
					error: err,
					params: property
				}
			}
		},
		priceChanged: function(price) {
			this.property.newPrice = price;
		},
		getWindowWidth: function(event) {
			this.windowWidth = document.documentElement.clientWidth;

			if(this.windowWidth < 839){
				this.responsive = true;
				console.log(this.windowWidth);
			}else{
				this.responsive = false;
			}
		},
		remove: function(index) {
			if (confirm('Are you sure you want to delete this photo?')) {
				this.property.images.splice(index, 1);
			}
		}
	},
	mounted: async function() {
		this.$nextTick(function() {
			window.addEventListener('resize', this.getWindowWidth);

			//Init
			this.getWindowWidth();
		});

		if(this.proPortalsPerProperty) {
			let portals, portalsCustom, baWebsite;

			try {
				[portals, portalsCustom, baWebsite] = await Promise.all([
					api({endpoint: this.config.services.portals, method: 'GET'}),
					api({endpoint: this.config.services.portalsCustom, method: 'GET'}),
					api({endpoint: this.config.services.website, path: '/get-site', method: 'GET'})
				]);

				portals.map((portal) => {
					if(portal.portalId === 'rm' && portal.live) {
						this.portalsList.push({
							id: portal.portalId,
							name: 'Rightmove'
						})
						this.portalsSelection.push(portal.portalId);
					}
					if(portal.portalId === 'zoopla' && portal.live) {
						this.portalsList.push({
							id: portal.portalId,
							name: 'Zoopla'
						})
						this.portalsSelection.push(portal.portalId);
					}
					if(portal.portalId === 'otm' && portal.live) {
						this.portalsList.push({
							id: portal.portalId,
							name: 'On The Market'
						})
						this.portalsSelection.push(portal.portalId);
					}
				});

				this.customPortals = portalsCustom;
				portalsCustom.map((portal) => {
					if(portal.active) {
						this.portalsList.push({
							id: portal.portalId,
							name: portal.portal_name+" (Custom Portal)"
						});
						this.portalsSelection.push(portal.portalId);
					}
				});

				if(baWebsite.response.Item){
					this.portalsList.push({
						id: 'baWebsite',
						name: 'BestAgent Website'
					});
					this.portalsSelection.push('baWebsite');
				}
			} catch(err) {
				throw {
					type: 'get-all-portals',
					error: err
				}
			}
		}
	},
	computed: {
		propertySubtypes: function() {
			return this.$store.state.propertyLists.propertyTypes[this.property.type];
		},
		propertySubtypesArray: function() {
			const subTypes = this.propertySubtypes;
			if(subTypes) {
				return Object.keys(subTypes).map((key) => {
					return [key, subTypes[key]];
				})
			} else {
				return [];
			}
		},
		propertyStatusArray: function() {
      if (!this.$store.state.propertyLists.propertyStatus || !this.$store.state.propertyLists.propertyStatus[this.property.serviceType]) {
        return {};
      }
			let statuses = this.$store.state.propertyLists.propertyStatus[this.property.serviceType];
      // Temporary quick&dirty fix, remove later
      statuses['appraisal'] = 'Appraisal';
			if (!statuses['withdrawn'])
				statuses['withdrawn'] = 'Withdrawn';
      if (statuses['Appraisal'])
        delete statuses['Appraisal'];
			return Object.keys(statuses).map((key) => {
				return [key, statuses[key]];
			})
		},
		furnishingStatusArray: function() {
			const statuses = this.$store.state.propertyLists.furnishingStatus;
			return Object.keys(statuses).map((key) => {
				return [key, statuses[key]];
			})
		},
		priceTermsArray: function() {
			const terms = this.$store.state.propertyLists.priceTerms;
			return Object.keys(terms).map((key) => {
				return [key, terms[key]];
			})
		},
		mainImage: function() {
			if(this.property.images.length > 0) {
				return this.property.images[0];
			} else {
				return '';
			}
		},
		fullAddress: function() {
			var address = '';
			if (this.property.address.buildingNumber != '') {
				address += this.property.address.buildingNumber + ', ';
			}
			if (this.property.address.flatNumber != '') {
				address += this.property.address.flatNumber + ' ';
			}
			address += this.property.address.street + ' ' + this.property.address.postcode;

			return address;
		},
		shortAddress: function() {
			var address = '';
			if (this.property.address.flatNumber != '') {
				address += this.property.address.flatNumber + ', ';
			}
			if (this.property.address.buildingNumber != '') {
				address += this.property.address.buildingNumber + ' ';
			}
			address += this.property.address.street;
			return address;
		},
		summary: function() {
			var summary = '';
			if (this.property.bedrooms == 0) {
				summary += 'Studio';
			} else {
				summary += this.property.bedrooms;
				summary += this.property.bedrooms == 1 ? ' bed' : ' beds';
			}
			// if not Studio add subtype
			if (this.property.bedrooms !== 0) {
				summary += ' ' + this.propertySubtypes[this.property.subtype];
			}
			return summary;
		},
		getStages: function() {
			var stages = Object.values(this.stages);
			var furnishingStage = stages.indexOf(this.stages.FURNISHING);
			stages.splice(furnishingStage, 1);

			return stages;
      },
		postcodeShort: function() {
			return this.property.address.postcode.split(' ')[0];
		},
	  proPortalsPerProperty: function() {
 		  return this.$store.getters.subscriptions ? this.$store.getters.subscriptions.indexOf('portal-selector') > -1 : false;
 	  }
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Properties-Add.vue